import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { endOfDay, startOfDay } from 'date-fns'
import constants from 'constants/constants'
import { eventSelector } from 'features/events/eventSlice'
import { useEventSlug } from 'hooks'
import { _, colors } from 'utils'
import routes from 'routes'
import Icon from '../../Icon'
import getSidebarConfig from './getSidebarConfig'
import SidebarItem from './SidebarItem'
import { selectBooth } from '../../../features/booth/config/fetchBoothSlice'

const S = {
    SidebarNav: styled.nav`
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100vh;
        padding: 80px 0 20px 0;
        background: ${colors.dark};
        
        transition: 0.3s;
        z-index: 10;
        overflow: auto;
    
        /* Hide scrollbar for Chrome, Safari and Opera */
        &::-webkit-scrollbar {
            display: none;
        }
    
        /* Hide scrollbar for IE, Edge and Firefox */
        & {
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
        }
    `,
    SidebarWrap: styled.div`
        width: 100%;
    `,
    BackToPortal: styled(Link)`
        margin-top: -8px;
        display: flex;
        align-items: center;
        padding-bottom: 16px;
        padding-left: 32px;
        text-decoration: none !important;
        border-bottom: 1px solid rgba(245, 246, 248, 0.1);
        & .text{
            margin-left: 8px;
            text-transform: uppercase;
            font-size: 16px;
            color: white;
        }
    `
}

const Sidebar = ({ isBooth }: { isBooth?: boolean }) => {
    const [currentOpen, setCurrentOpen] = useState('')
    const booth = useSelector(selectBooth)
    const allowJobs = booth?.max_job_openings > 0
    let sidebarConfig = getSidebarConfig(isBooth, constants.isLite, allowJobs)
    const eventSlug = useEventSlug()
    const eventData = useSelector(eventSelector)
    if (!eventData?.enableGroupSessions) {
        sidebarConfig = sidebarConfig.filter((item) => item.route?.path !== routes.groupSessions.path)
    }
    if (!eventData?.endDate || startOfDay(new Date()) < endOfDay(new Date(eventData?.endDate))) {
        sidebarConfig = sidebarConfig.filter((item) => item.route?.path !== routes.gdpr.path)
    }

    return (
        <S.SidebarNav>
            <S.SidebarWrap>
                {isBooth && eventData && (
                    <S.BackToPortal to={`/${eventSlug}/booths`}>
                        <Icon icon="arrowLeftCircle" color="#2DB3AC" size={22} />
                        <span className="text">{_('portal_menu.back_to_booths')}</span>
                    </S.BackToPortal>
                )}
                {sidebarConfig.map((item, index) => (
                    <SidebarItem
                        item={item}
                        key={index}
                        currentOpen={currentOpen}
                        onChangeCurrentOpen={setCurrentOpen}
                    />
                ))}
            </S.SidebarWrap>
        </S.SidebarNav>
    )
}

export default Sidebar
